import { ListPage } from 'pageModules/ListPage';

export default ListPage;
